import { BULK_MEDIUM_SCOPES } from 'features/ManageCampaigns/utils/inviteBulkMediumHelpers'
import { INVITE_EMAIL_DESIGN_APPLY_SCOPES } from 'services/api/inviteEmailDesign'

export function resolveInviteEmailDesignApplyScope(bulkScope) {
  if (bulkScope === BULK_MEDIUM_SCOPES.all) {
    return INVITE_EMAIL_DESIGN_APPLY_SCOPES.all
  }

  if (bulkScope === BULK_MEDIUM_SCOPES.ota) {
    return INVITE_EMAIL_DESIGN_APPLY_SCOPES.ota
  }

  return INVITE_EMAIL_DESIGN_APPLY_SCOPES.direct
}

export default resolveInviteEmailDesignApplyScope
